import { useState, useEffect } from 'react';

const useElementWidth = elementRef => {
    const [width, setWidth] = useState('auto');

    useEffect(() => {
        const element = elementRef?.current;

        if (!element) {
            return;
        }

        const observer = new ResizeObserver(entries => {
            for (const entry of entries) {
                setWidth(entry.contentRect.width);
            }
        });

        observer.observe(element);

        // eslint-disable-next-line consistent-return
        return () => {
            observer.disconnect();
        };
    }, [elementRef]);

    return width;
};

export default useElementWidth;
